<template>
  <el-dialog
    title="编辑信息"
    center
    :append-to-body="true"
    :visible="show"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    width="760px"
    @close="handleClose"
  >
    <el-form
      ref="formValidates"
      :model="form"
      :rules="rules"
      label-width="80px"
      style="padding-right: 20px"
    >
      <el-form-item label="姓名" prop="name" style="width: calc(50% - 30px);display: inline-block;">
        <el-input v-model.trim="form.name" :maxlength="10" placeholder="请填写姓名" />
      </el-form-item>
      <el-form-item
        label="身份证号"
        prop="id_card"
        style="width: 50%;margin-left: 30px;display: inline-block;"
      >
        <el-input v-model.trim="form.id_card" placeholder="请填写身份证号" @blur="onIdCardBlur" />
      </el-form-item>
      <el-form-item
        label="联系方式"
        prop="phone"
        style="width: calc(50% - 30px);display: inline-block;"
      >
        <el-input v-model.trim="form.phone" placeholder="请填写联系方式" />
      </el-form-item>
      <el-form-item
        label="筛查来源"
        prop="origin"
        style="width: 50%;margin-left: 30px;display: inline-block;"
      >
        <el-select
          v-model="form.origin"
          placeholder="请选择筛查来源"
          no-data-text="请选择筛查来源"
          style="width: 100%;"
        >
          <el-option
            v-for="(item, index) in origins"
            :value="item.value"
            :key="index"
            :label="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="性别" prop="gender" style="width: calc(50% - 30px);display: inline-block;">
        <el-select
          v-model="form.gender"
          placeholder="请选择性别"
          no-data-text="请选择性别"
          style="width: 100%;"
        >
          <el-option
            v-for="(item,index) in sexList"
            :value="item.value"
            :key="index"
            :label="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="年龄"
        prop="age"
        style="width: 50%;margin-left: 30px;display: inline-block;"
      >
        <el-input v-model.trim="form.age" placeholder="请填写年龄" />
      </el-form-item>
      <el-form-item
        label="出生日期"
        prop="birthday"
        style="width: calc(50% - 30px);margin-right:calc(30px + 20%);display: inline-block;"
      >
        <el-date-picker
          v-model="form.birthday"
          type="date"
          placeholder="请选择出生日期"
          value-format="yyyy-MM-dd"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item
        label="诊断"
        prop="diagnosis"
        style="width: calc(50% - 30px);display: inline-block;"
      >
        <el-select
          v-model="form.diagnosis"
          filterable
          remote
          :remote-method="onDiagnosisSearch"
          :loading="loadingDiagnosis"
          placeholder="输入诊断名称搜索"
          style="width: 100%;"
        >
          <el-option
            v-for="(i, index) in diagnosisLists"
            :value="i.diagnosis_name"
            :key="'dia_' + index"
            :label="i.diagnosis_name"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="其他诊断"
        prop="other_diagnosis"
        style="width: 50%;margin-left: 30px;display: inline-block;"
      >
        <el-select
          v-model="form.other_diagnosis"
          :multiple-limit="2"
          multiple
          filterable
          remote
          :remote-method="onDiagnosisSearchOther"
          :loading="loadingDiagnosisOther"
          placeholder="输入诊断名称搜索"
          style="width: 100%;"
        >
          <el-option
            v-for="i in diagnosisListsOther"
            :value="i.diagnosis_name"
            :key="i.diagnosis_name"
            :label="i.diagnosis_name"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="地址"
        prop="provinceName"
        style="width: calc(60% - 60px);display: inline-block"
      >
        <el-cascader
          v-model="form.provinceName"
          :options="options"
          style="width: 100%"
          @change="handleAddressChange"
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="address" style="width: 40%;margin-left: -60px;display: inline-block">
        <el-input
          v-model.trim="form.address"
          placeholder="请填写具体地址"
          style="width: calc(100% + 120px)"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getDiagnosis } from '../../../api/person'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        name: '',
        gender: '',
        age: '',
        id_card: '',
        address: '',
        phone: '',
        birthday: '',
        origin: '',
        provinceName: '',
        diagnosis: '',
        other_diagnosis: '',
      },
      rules: {
        name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        id_card: [
          { required: true, message: '请填写身份证号', trigger: 'blur' },
          { required: true, message: '请填写身份证号', trigger: 'change' },
          {
            type: 'string',
            min: 18,
            max: 18,
            message: '请填写合法身份证号',
            trigger: 'blur',
          },
        ],
        provinceName: [
          {
            type: 'array',
            required: true,
            message: '请选择地址',
            trigger: 'blur',
          },
          {
            type: 'array',
            required: true,
            message: '请选择地址',
            trigger: 'change',
          },
        ],
        // address: [
        // { required: true, message: '请填写具体地址', trigger: 'blur' },
        // { required: true, message: '请填写具体地址', trigger: 'change' },
        // ],
        phone: [
          { required: true, message: '请填写本人电话', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: ['blur', 'change'],
          },
        ],
        origin: [
          { required: true, message: '请选择筛查来源', trigger: 'change' },
        ],
        // birthday: [
        //   {
        //     required: true,
        //     message: '请选择出生日期',
        //     trigger: 'change',
        //   },
        // ],
      },
      sexList: [
        {
          value: '1',
          label: '男',
        },
        {
          value: '0',
          label: '女',
        },
      ],
      origins: [
        {
          value: '微信公众号',
          label: '微信公众号',
        },
        {
          value: '微信小程序',
          label: '微信小程序',
        },
        {
          value: 'APP',
          label: 'APP',
        },
        {
          value: '线下',
          label: '线下',
        },
        {
          value: '其他',
          label: '其他',
        },
      ],
      region: [],
      options: regionData,
      diagnosis_code: '',
      diagnosisLists: [],
      diagnosisListsOther: [],
      other_diagnosis_code: [],
      loadingDiagnosis: false,
      loadingDiagnosisOther: false,
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.form = JSON.parse(JSON.stringify(this.info))
        const arr = []
        this.region = [this.form.province, this.form.city, this.form.county]
        if (this.form.province) {
          arr.push(TextToCode[this.form.province].code)
          if (!TextToCode[this.form.province][this.form.city]) {
            this.form.city = '市辖区'
          }
          arr.push(TextToCode[this.form.province][this.form.city].code)
          arr.push(
            TextToCode[this.form.province][this.form.city][this.form.county]
              .code
          )
        }
        this.form.provinceName = arr
        if (this.info.other_diagnosis) {
          this.form.other_diagnosis = this.info.other_diagnosis.split(',')
        }
        if (this.info.channel) {
          this.form.origin = this.info.channel
        }
        if (this.info.gender) {
          this.form.gender = this.info.gender.toString()
        }
        if (this.form.id_card) {
          this.onIdCardBlur()
        }
      }
    },
  },
  methods: {
    onIdCardBlur() {
      // 身份证输入框失去焦点
      const id_card_no = this.form.id_card
      if (id_card_no && id_card_no.length === 18) {
        const birth_year = Number(id_card_no.substring(6, 10))
        const birth_day =
          id_card_no.substring(6, 10) +
          '-' +
          id_card_no.substring(10, 12) +
          '-' +
          id_card_no.substring(12, 14)
        const gender = Number(id_card_no.substring(16, 17)) % 2

        this.form.gender = gender.toString()
        this.form.age = new Date().getFullYear() - birth_year
        this.form.birthday = birth_day
      }
    },
    onDiagnosisSearch(query) {
      let obj = {
        page: 1,
        size: 100,
        name: query,
      }
      this.loadingDiagnosis = true
      getDiagnosis(obj).then((res) => {
        this.loadingDiagnosis = false
        if (res.code === 0) {
          this.diagnosisLists = res.data
        } else {
          this.$Message.warning(res.message)
        }
      })
    },
    onDiagnosisSearchOther(query) {
      let obj = {
        page: 1,
        size: 100,
        name: query,
      }
      this.loadingDiagnosisOther = true
      getDiagnosis(obj).then((res) => {
        this.loadingDiagnosisOther = false
        if (res.code === 0) {
          this.diagnosisListsOther = res.data
        } else {
          this.$Message.warning(res.message)
        }
      })
    },
    handleAddressChange() {
      const arr = []
      for (let i = 0; i < this.form.provinceName.length; i++) {
        arr.push(CodeToText[this.form.provinceName[i]])
      }
      this.region = arr
    },
    handleClose() {
      this.$emit('close')
    },
    handleSubmit() {
      this.$refs.formValidates.validate((valid) => {
        if (valid) {
          this.other_diagnosis_code = []
          if (
            this.form.other_diagnosis &&
            this.form.other_diagnosis.length > 0
          ) {
            this.diagnosisListsOther.forEach((v) => {
              this.form.other_diagnosis.forEach((j, index) => {
                if (j == v.diagnosis_name) {
                  if (
                    this.other_diagnosis_code.includes(v.icd_diagnosis_code)
                  ) {
                  } else {
                    this.other_diagnosis_code.push(v.icd_diagnosis_code)
                  }
                }
              })
            })
          }
          const { form } = this
          const info = JSON.parse(JSON.stringify(this.info))
          const params = Object.assign({}, info, {
            person_id: this.info.id,
            diagnosis: form.diagnosis,
            diagnosis_code: this.diagnosis_code,
            other_diagnosis:
              form.other_diagnosis && form.other_diagnosis.length > 0
                ? form.other_diagnosis.join(',')
                : '',
            other_diagnosis_code: this.other_diagnosis_code.join(','),
            name: form.name,
            gender: form.gender,
            age: form.age,
            id_card: form.id_card,
            phone: form.phone,
            birthday: form.birthday,
            address: form.address,
            channel: form.origin,
            province: this.region[0],
            city: this.region[1],
            county: this.region[2],
          })
          this.$emit('submit', params)
        }
      })
    },
  },
}
</script>
